import { Repeater, types } from "react-bricks/frontend"
import { Spacer, SpacerVariant, spacerOptions } from "../components/layout"

import React from "react"
import classNames from "classnames"
import { options } from "../../types"

enum Type {
    Default = "default",
    Article = "article",
}

export interface TableProps {
    spacerTop: boolean
    spacerBottom: boolean
    variantTop?: SpacerVariant
    variantBottom?: SpacerVariant
    inline?: boolean
    type?: Type
}

const Table: types.Brick<TableProps> = ({
    spacerTop,
    spacerBottom,
    variantTop,
    variantBottom,
    inline,
    type = Type.Default,
}) => {
    return (
        <div
            className={classNames("mx-auto box-border w-full", {
                "px-0 sm:px-6.25 md:px-10 lg:max-w-[1560px] lg:px-15": !inline && type === Type.Default,
                "box-content px-0 sm:max-w-[600px] sm:px-6.25 md:px-10 lg:max-w-[900px] lg:px-15":
                    !inline && type === Type.Article,
            })}
        >
            <Spacer variant={!spacerTop || inline ? SpacerVariant.None : variantTop} />
            <div
                className={classNames("overflow-hidden border border-solid border-border-tide sm:rounded-base", {
                    "rounded-xs": inline,
                })}
            >
                <table className="w-full border-collapse text-xs sm:text-md">
                    <Repeater propName="rows" />
                </table>
            </div>
            <Spacer variant={!spacerBottom || inline ? SpacerVariant.None : variantBottom} />
        </div>
    )
}

Table.schema = {
    name: "Table",
    label: "Table",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/Table.png`,
    repeaterItems: [
        {
            name: "rows",
            itemType: "TableRow",
            min: 1,
        },
    ],
    sideEditProps: [
        {
            name: "type",
            label: "Type",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: options<typeof Type>(Type),
                display: types.OptionsDisplay.Radio,
            },
        },
        {
            groupName: "Spacer",
            props: [
                {
                    name: "spacerTop",
                    label: "Spacer Top",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantTop",
                    label: "Spacer Variant",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptions,
                        display: types.OptionsDisplay.Select,
                    },
                    show: props => props.spacerTop === true,
                },
                {
                    name: "spacerBottom",
                    label: "Spacer Bottom",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantBottom",
                    label: "Spacer Variant",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptions,
                        display: types.OptionsDisplay.Select,
                    },
                    show: props => props.spacerBottom === true,
                },
            ],
        },
    ],
    getDefaultProps: () => ({
        spacerTop: true,
        spacerBottom: true,
        variantTop: SpacerVariant.Base,
        variantBottom: SpacerVariant.Base,
        inline: false,
        type: Type.Default,
    }),
}

export default Table
